import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';
import { MasterAttributeDataModel } from 'src/app/model/shared/components/entities/entities-profile/entities-widgets-collection/asset-condition';
import { GeneralService } from 'src/app/services/general.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { EntitiesServiceService } from 'src/app/shared/services';

@Component({
  selector: 'app-common-gauge',
  templateUrl: './common-gauge.component.html',
  styleUrls: ['./common-gauge.component.css'],
})
export class CommonGaugeComponent implements OnInit {

  @Input() entityDetails: any;
  @Input() widgetData: {refreshRate: number, title: string, widgetDataAttributes: {attributeName: string, unit: string} };
  @Input() entityId: string;

  isloader: boolean = true;
  isError: boolean = false;
  masterAttData: MasterAttributeDataModel;
  gaugeData: any = [];

  private _intervalTimer: any;
  private _entityAttributeValueSubscription: Subscription;

  constructor(
    private _service: EntitiesServiceService,
    private _sharedService: ServicecallService,
    private _generalService: GeneralService,
    private _datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this._fetchAttDetails();
  }

  ngOnDestroy(): void {
    this._entityAttributeValueSubscription?.unsubscribe();
    this._clearTimer();
  }

  /**
   * Infos hover label
   * @returns
   */
  infoHoverLabel() {
    const profileConfig = this._sharedService.getConfigurationBasedOnCategory(this.entityDetails)
      ? this._sharedService.getConfigurationBasedOnCategory(this.entityDetails)
      : [];

    const range = profileConfig?.widgetGaugeRange?.[this.widgetData?.widgetDataAttributes?.attributeName];

    return (
      '\nCurrent Value: ' +
      this.masterAttData?.value?.toString() +
      '\nOptimal Range: ' +
      this.masterAttData?.thresholdLow?.toString() +
      ' to ' +
      this.masterAttData?.thresholdHigh?.toString() +
      '\nRange: ' +
      (range?.length ? range?.[0].toString() : '') +
      ' to ' +
      (range?.length ? range?.[1].toString() : '')
    );
  }

  /**
   * Fetchs attribute details
   */
  private _fetchAttDetails() {
    const [startTime, endTime] = this._generalService?.getStartEndTimeByDate();
    const payload = {
      attributes: [this.widgetData?.widgetDataAttributes?.attributeName],
      entityId: this.entityId,
      entityCategory: this.entityDetails?.category,
      from: this._datePipe.transform(startTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ')
    };
    this._entityAttributeValueSubscription = this._service
      .entityAttributeValue(payload)
      .subscribe({
        next: (result: any) => {
          this.masterAttData = result?.length ? result[0] : [];
          this.isloader = false;
          this._setGaugeData();
        },
        error: (error) => {
          if (error) {
            this.isloader = false;
            this.isError = true;
            this.masterAttData.value = 0;
            this._setGaugeData();
          }
        },
      });
  }

  /**
   * Sets gauge data
   */
  private _setGaugeData() {
    const profileConfig = this._sharedService.getConfigurationBasedOnCategory(this.entityDetails)
      ? this._sharedService.getConfigurationBasedOnCategory(this.entityDetails)
      : [];
    const range = profileConfig?.widgetGaugeRange?.[this.widgetData?.widgetDataAttributes?.attributeName];

    this.gaugeData = [
      [
        {
          type: 'indicator',
          mode: 'gauge+number',
          value: this.masterAttData?.value ? this.masterAttData?.value : 0,
          gauge: {
            axis: {
              range: range ? range : [null, null],
              showticklabels: false,
              ticks: '',
            },
            bar: { color: '#055C7B', thickness: 0.3 },
            steps: [
              {
                range: [
                  this.masterAttData?.thresholdLow,
                  this.masterAttData?.thresholdHigh,
                ],
                color: '#2EDB96',
                thickness: 0.5,
              },
              {
                range: [
                  range ? range[0] : null,
                  this.masterAttData?.thresholdLow,
                ],
                color: '#F2F4F3',
                thickness: 0.3,
              },
              {
                range: [this.masterAttData?.value, range ? range[1] : null],
                color: '#F2F4F3',
                thickness: 0.3,
              },
            ],
            bordercolor: 'transparent',
          },
          height: 200,
          suffix:this.widgetData?.widgetDataAttributes?.unit ? this.widgetData?.widgetDataAttributes?.unit : "",
          annotation: [
            {
              text: '',
              showarrow: false,
              y: 0.6,
              font: {
                family: 'Inter',
                size: 18,
                color: '#615E83',
              },
            },
          ],
        },
      ],
    ];
    this._refreshApi();
  }

  /**
   * Refreshs api
   */
  private _refreshApi() {
    if (+this.widgetData?.refreshRate) {
      this._clearTimer();
      this._intervalTimer = setInterval(() => {
        this._fetchAttDetails();
      }, +this.widgetData?.refreshRate);
      this.isError = false;
    }
  }

  /**
   * Clears timer
   */
  private _clearTimer() {
    if (this._intervalTimer) {
      clearInterval(this._intervalTimer);
    }
  }
}
